export default __webpack_public_path__ + "9c0b005e41e4e59301c9e30dd5f84acd.png";